var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 20,
    viewBox: "0 0 16 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4375 8.13585H5.28125V5.33943C5.28125 3.79766 6.50106 2.543 8 2.543C9.49894 2.543 10.7188 3.79766 10.7188 5.33943H12.5312C12.5312 2.76951 10.4985 0.678711 8 0.678711C5.50147 0.678711 3.46875 2.76951 3.46875 5.33943V8.13585H2.5625C2.0818 8.13585 1.62078 8.33227 1.28087 8.68189C0.940959 9.03151 0.75 9.5057 0.75 10.0001V17.4573C0.75 17.9517 0.940959 18.4259 1.28087 18.7755C1.62078 19.1252 2.0818 19.3216 2.5625 19.3216H13.4375C13.9182 19.3216 14.3792 19.1252 14.7191 18.7755C15.059 18.4259 15.25 17.9517 15.25 17.4573V10.0001C15.25 9.5057 15.059 9.03151 14.7191 8.68189C14.3792 8.33227 13.9182 8.13585 13.4375 8.13585ZM6.24278 13.2617C6.35418 12.8231 6.617 12.4411 6.98217 12.1873C7.34734 11.9334 7.78987 11.8249 8.22711 11.8821C8.66435 11.9393 9.06639 12.1583 9.35814 12.4981C9.6499 12.8379 9.8114 13.2754 9.8125 13.7287C9.81198 14.0547 9.72794 14.3748 9.56884 14.6568C9.40974 14.9388 9.1812 15.1726 8.90625 15.3348V17.4573H7.09375V15.3348C6.75084 15.1327 6.48189 14.8204 6.32817 14.4459C6.17445 14.0715 6.14445 13.6554 6.24278 13.2617Z",
    fill: "#8E8E8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUnlock);
export default __webpack_public_path__ + "static/media/ico-unlock.fe11e1c64fc5364774fef1334c7a779c.svg";
export { ForwardRef as ReactComponent };